var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActionCloseCircle = function SvgActionCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.536 8.464a.5.5 0 0 1 0 .708L12.707 12l2.829 2.828a.5.5 0 1 1-.708.708L12 12.707l-2.828 2.829a.5.5 0 1 1-.708-.708L11.293 12 8.464 9.172a.5.5 0 1 1 .708-.708L12 11.293l2.828-2.829a.5.5 0 0 1 .708 0M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0 1c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
    clipRule: "evenodd"
  })));
};
export default SvgActionCloseCircle;